// ============================================================
// NURTURED - Shopify-ready homepage interactivity
// ============================================================
(function () {
  'use strict';

  if (window.__zaisHomeInitialized) return;
  window.__zaisHomeInitialized = true;

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Scroll reveal ----------
  function initScrollReveal() {
    var animated = Array.prototype.slice.call(document.querySelectorAll('.zais-home-section [data-animate]'));
    if (!animated.length) return;

    animated.forEach(function (el) {
      var delay = el.getAttribute('data-animate-delay');
      if (delay) el.style.setProperty('--animate-delay', delay + 'ms');
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    document.documentElement.classList.add('motion-ready');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    requestAnimationFrame(function () {
      animated.forEach(function (el) { observer.observe(el); });
    });
  }

  // ---------- Hero product preview ----------
  function initHeroProductPreview() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.hero-product'));
    var nav = document.querySelector('.hero__product-nav');
    var preview = document.getElementById('hero-product-preview');
    var image = document.getElementById('hero-preview-image');
    var focusBox = document.querySelector('.hero__focus');
    var focusImage = document.getElementById('hero-focus-image');
    var tag = document.getElementById('hero-preview-tag');
    var name = document.getElementById('hero-preview-name');
    var copy = document.getElementById('hero-preview-copy');
    var note = document.getElementById('hero-preview-note');
    var heroHeading = document.getElementById('hero-heading');
    var heroLede = document.getElementById('hero-lede');
    var heroPrimaryCta = document.querySelector('.hero__ctas .btn--primary');
    if (!buttons.length || !preview || !image || !focusImage || !tag || !name) return;

    var slideDuration = 5200;
    var initialAutoDelay = 12000;
    var nextSlidePreloadDelay = 7000;
    var autoTimer = null;
    var firstAutoTimer = null;
    var preloadTimer = null;
    var preloadedImages = {};
    var activeIndex = Math.max(0, buttons.findIndex(function (btn) {
      return btn.classList.contains('is-active');
    }));

    if (nav) nav.style.setProperty('--hero-slide-duration', slideDuration + 'ms');

    function getSlideImageData(btn) {
      var nextImage = btn.dataset.productImage || image.getAttribute('src');
      var responsiveSources = [
        [btn.getAttribute('data-product-image-480'), '480w'],
        [btn.getAttribute('data-product-image-720'), '720w'],
        [btn.getAttribute('data-product-image-960'), '960w'],
        [btn.getAttribute('data-product-image-1280'), '1280w'],
        [btn.getAttribute('data-product-image-1600'), '1600w'],
        [btn.dataset.productImageOriginal, btn.dataset.productImageOriginalWidth + 'w']
      ].filter(function (source) {
        return source[0] && source[1] !== 'undefinedw';
      });

      return {
        src: nextImage,
        srcset: responsiveSources.map(function (source) {
          return source[0] + ' ' + source[1];
        }).join(', ')
      };
    }

    function preloadSlide(btn) {
      if (!btn) return;

      var imageData = getSlideImageData(btn);
      if (!imageData.src || preloadedImages[imageData.src]) return;

      var preload = new Image();
      preload.fetchPriority = 'low';
      if (imageData.srcset) {
        preload.srcset = imageData.srcset;
        preload.sizes = '100vw';
      }
      preload.src = imageData.src;
      preloadedImages[imageData.src] = preload;
    }

    function scheduleNextSlidePreload(delay) {
      if (prefersReducedMotion || buttons.length < 2) return;
      window.clearTimeout(preloadTimer);
      preloadTimer = window.setTimeout(function () {
        preloadSlide(buttons[(activeIndex + 1) % buttons.length]);
      }, delay);
    }

    function updatePreview(btn, shouldRestart) {
      if (!btn) return;

      buttons.forEach(function (item) {
        item.classList.toggle('is-active', item === btn);
        item.setAttribute('aria-pressed', item === btn ? 'true' : 'false');
      });

      activeIndex = buttons.indexOf(btn);

      var rail = btn.closest('.hero-product-rail');
      var railCanScroll = rail && getComputedStyle(rail).display !== 'contents' && rail.scrollWidth > rail.clientWidth;
      if (railCanScroll && btn.scrollIntoView) {
        btn.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }

      var imageData = getSlideImageData(btn);
      var nextImage = imageData.src;
      var nextFocusImage = btn.dataset.productFocusImage || nextImage;
      var nextSrcset = imageData.srcset;
      var currentImage = image.getAttribute('src');
      var didApply = false;

      function applyContent() {
        if (didApply) return;
        didApply = true;
        if (nextSrcset) {
          image.setAttribute('srcset', nextSrcset);
          image.setAttribute('sizes', '100vw');
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
        }
        focusImage.removeAttribute('srcset');
        focusImage.removeAttribute('sizes');
        image.setAttribute('src', nextImage);
        image.setAttribute('alt', btn.dataset.productName || '');
        focusImage.setAttribute('src', nextFocusImage);
        focusImage.setAttribute('alt', btn.dataset.productName || '');
        tag.textContent = btn.dataset.productTag || '';
        name.textContent = btn.dataset.productName || '';
        if (copy) copy.textContent = btn.dataset.productCopy || '';
        if (note) note.textContent = btn.dataset.productNote || '';
        if (heroHeading) heroHeading.textContent = btn.dataset.heroTitle || '';
        if (heroLede) heroLede.textContent = btn.dataset.heroDescription || '';
        preview.classList.remove('is-changing');
        if (focusBox) focusBox.classList.remove('is-changing');
        scheduleNextSlidePreload(1800);
      }

      preview.classList.add('is-changing');
      if (focusBox) focusBox.classList.add('is-changing');

      if (nextImage === currentImage) {
        applyContent();
      } else {
        var preload = new Image();
        if (nextSrcset) {
          preload.srcset = nextSrcset;
          preload.sizes = '100vw';
        }
        preload.onload = function () {
          applyContent();
        };
        preload.onerror = function () {
          applyContent();
        };
        preload.src = nextImage;
        if (preload.decode) {
          preload.decode().then(applyContent).catch(function () {});
        }
      }

      if (shouldRestart) restartAutoSlide();
    }

    function goToNextSlide() {
      var nextIndex = (activeIndex + 1) % buttons.length;
      updatePreview(buttons[nextIndex], false);
    }

    function stopAutoSlide() {
      window.clearTimeout(firstAutoTimer);
      window.clearInterval(autoTimer);
      firstAutoTimer = null;
      autoTimer = null;
    }

    function startAutoSlide() {
      if (prefersReducedMotion || buttons.length < 2) return;
      stopAutoSlide();
      autoTimer = window.setInterval(goToNextSlide, slideDuration);
    }

    function scheduleFirstAutoSlide() {
      if (prefersReducedMotion || buttons.length < 2) return;
      stopAutoSlide();
      firstAutoTimer = window.setTimeout(function () {
        firstAutoTimer = null;
        goToNextSlide();
        startAutoSlide();
      }, initialAutoDelay);
    }

    function restartAutoSlide() {
      if (prefersReducedMotion || buttons.length < 2) return;
      startAutoSlide();
    }

    buttons.forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
      btn.addEventListener('click', function () { updatePreview(btn, true); });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoSlide();
        window.clearTimeout(preloadTimer);
      } else {
        restartAutoSlide();
        scheduleNextSlidePreload(1800);
      }
    });

    scheduleNextSlidePreload(nextSlidePreloadDelay);
    scheduleFirstAutoSlide();
  }

  // ---------- Concern card image carousels ----------
  function initConcernCarousels(root) {
    var scope = root || document;
    var carousels = Array.prototype.slice.call(scope.querySelectorAll('[data-concern-carousel]'));

    carousels.forEach(function (carousel) {
      if (carousel.getAttribute('data-carousel-initialized') === 'true') return;

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'));
      var previous = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (slides.length < 2) return;

      var activeIndex = 0;
      var timer = null;
      var card = carousel.closest('.concern-card');
      carousel.setAttribute('data-carousel-initialized', 'true');

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      function show(index, restart) {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        if (restart) start();
      }

      function start() {
        if (prefersReducedMotion) return;
        stop();
        timer = window.setInterval(function () { show(activeIndex + 1, false); }, 5200);
      }

      function controlClick(event, index) {
        event.preventDefault();
        event.stopPropagation();
        show(index, true);
      }

      if (previous) previous.addEventListener('click', function (event) {
        controlClick(event, activeIndex - 1);
      });
      if (next) next.addEventListener('click', function (event) {
        controlClick(event, activeIndex + 1);
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (event) {
          controlClick(event, parseInt(dot.getAttribute('data-carousel-dot'), 10) || 0);
        });
      });

      if (card) {
        card.addEventListener('mouseenter', stop);
        card.addEventListener('mouseleave', start);
        card.addEventListener('focusin', stop);
        card.addEventListener('focusout', function (event) {
          if (!card.contains(event.relatedTarget)) start();
        });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0, false);
      start();
    });
  }

  // ---------- Load below-the-fold interactions when they approach ----------
  function initDeferredHomepageFeatures() {
    var targets = Array.prototype.slice.call(
      document.querySelectorAll('[data-review-carousel], .faq__list')
    );
    if (!targets.length) return;

    var loader = document.getElementById('zais-home-script');
    var deferredSrc = loader && loader.getAttribute('data-deferred-src');
    if (!deferredSrc) return;

    var requested = false;
    function loadDeferredFeatures() {
      if (requested || window.__zaisHomeDeferredInitialized) return;
      requested = true;

      var script = document.createElement('script');
      script.src = deferredSrc;
      script.async = true;
      document.head.appendChild(script);
    }

    if (!('IntersectionObserver' in window)) {
      window.setTimeout(loadDeferredFeatures, 2500);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      loadDeferredFeatures();
    }, { rootMargin: '500px 0px', threshold: 0 });

    targets.forEach(function (target) { observer.observe(target); });
  }

  initScrollReveal();
  initHeroProductPreview();
  initConcernCarousels();
  initDeferredHomepageFeatures();

  document.addEventListener('shopify:section:load', function (event) {
    initConcernCarousels(event.target);
  });
})();
